import Conf from '../../configuration'
import Storage from '@/helpers/storage'
import IndexedDb from '@/modules/indexedDb'
import Store from '@/store'

export default {

    get: (Vue) => {

        return Vue.$i18n.locale

    },

    set: (Vue, lang) => {

        setLang(Vue, lang)

    },

    created (Vue) {

        const storageLang = Storage.getItem('lang')

        if (isValidLang(storageLang)) {

            setLang(Vue, storageLang)

        } else {

            const navLang = (window.navigator.userLanguage || window.navigator.language).substring(0, 2)

            setLang(Vue, navLang)

        }

    }

}

function updateLang (Vue, lang) {

    Vue.$i18n.locale = lang
    Vue.$router.history.base = `/${lang}`
    Storage.setItem('lang', lang)
    Store.dispatch('setLang', lang)
    IndexedDb.saveLang(lang)

    const path = window.location.pathname

    let goTo = ''

    const query = window.location.href.split('?')[1]

    Vue.$router.options.routes.forEach(obj => {

        if(obj.path === path) {

            goTo = path

        } else if (obj.path === path.substring(3)) {

            goTo = path.substring(3)
        }
    })

    if (query) {
        goTo = `${ goTo}?${ query }`
    }
    // rewrite url
    Vue.$router.push({ path: goTo})

}

function isValidLang (lang) {

    const regex = new RegExp(`^(${Conf.languages.join('|')})$`)

    return regex.test(lang)

}

function setLang (Vue, lang = Conf.defaultLanguage) {

    if (Vue.$i18n.messages[lang]) {

        updateLang(Vue, lang)

    } else {

        return Vue.$http.get(`/i18n/${lang}.json`)
            .then(response => {

                Vue.$i18n.setLocaleMessage(lang, response.body)

                updateLang(Vue, lang)

            })
            .catch(error => {
            })
    }

}
